import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "Store/configureStore";

export const userStateSelector = (state: RootState) => state.user;

export const usersSelector = createSelector(
  [userStateSelector, (_: RootState, userId: string) => userId],
  (userState, userId) => userState.data?.[userId]
);
